import { CollectionHighlighted } from 'searchCollection';
import getCollection from 'services/collections/getCollectionClient';
import { DEFAULT_IMAGE, ROUTE_TYPE } from 'constants/index';
import { createLinkToRedirect } from 'utils/createLinkToRedirect';

export async function getHighlightedCollections(): Promise<CollectionHighlighted[]> {
  try {
    const allCollection = await getCollection();

    return (
      allCollection?.matrices
        ?.filter((item) => item?.highlighted && item.highlighted.trim() !== '')
        ?.map((item) => ({
          label: item?.label,
          icon: item?.images?.icon || item?.images?.banner || DEFAULT_IMAGE,
          link: createLinkToRedirect({
            param: item?.slug,
            routeType: ROUTE_TYPE.COLLECTION,
            item: {
              ...item,
              urn: '',
            },
            userLocation: null,
          }),
          highlighted: item?.highlighted,
        }))
        ?.sort((a, b) => Number(b.highlighted) - Number(a.highlighted)) || []
    );
  } catch (error) {
    return [];
  }
}
